export const UPDATE_SELLER_SKILLS = 'UPDATE_SELLER_SKILLS';

export const updateSellerSkills = (payload: string[]) => ({
    type: UPDATE_SELLER_SKILLS,
    payload,
});

export default (state = [] as string[], action: ReturnType<typeof updateSellerSkills>) =>
    action.type === UPDATE_SELLER_SKILLS ? action.payload : state;
